export default {
  strict: true,
  namespaced: true,
  state: {
    id: '',
    code: '',
    type: '',
    amount: '',
    start: '',
    end: '',
    origPickup: '',
    origDropoff: ''
  },
  mutations: {
    setDiscountData (state, data) {
      for (let field in data) {
        state[field] = data[field]
      }
    }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/discount-code/index.js